export const ALLOCATION_SUCCESS_MESSAGES: Record<string, string> = {
  branch: 'Branches allocated successfully',
  function: 'Functions allocated successfully',
  tpsp: 'Third Party Service Providers allocated successfully',
  contractualArrangements: 'Contractual Arrangements allocated successfully',
  entity: 'Allocation saved successfully',
  ictSystems: 'ICT Systems allocated successfully',
  ictServices: 'ICT Services allocated successfully',
};
